"use client"

import { getQueryStringPartner } from "@/utils/string/getQueryStringPartner"
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime"
import { usePathname, useRouter } from "next/navigation"

export const useTERouter = () => {
  const router = useRouter()
  const pathname = usePathname()

  const push: AppRouterInstance['push'] = (href, options) => {
    const lang = !href.startsWith('/en') && !href.startsWith('/vi')
      ? pathname.startsWith("/en")
        ? "/en" : pathname.startsWith("/vi")
          ? "/vi" : ""
      : href.startsWith("/en")
        ? "/en" : href.startsWith("/vi")
          ? "/vi" : ""
          
    let _href = `${lang}${href.replace("/en/", "/").replace("/vi/", "/").replace("/vi", "/").replace("/en", "/")}`
    const partnerQs = getQueryStringPartner()
    if (partnerQs) {
      _href = _href.indexOf("?") > -1 ? `${_href}&${partnerQs}` : `${_href}?${partnerQs}`
    }

    router.push(
      _href,
      options
    )
  }
  const refresh: AppRouterInstance['refresh'] = (...params) => router.refresh(...params)
  const replace: AppRouterInstance['replace'] = (href, options) => {
    const lang = !href.startsWith('/en') && !href.startsWith('/vi')
      ? pathname.startsWith("/en")
        ? "/en" : pathname.startsWith("/vi")
          ? "/vi" : ""
      : href.startsWith("/en")
        ? "/en" : href.startsWith("/vi")
          ? "/vi" : ""
          
    const _href = `${lang}${href.replace("/en/", "/").replace("/vi/", "/").replace("/vi", "/").replace("/en", "/")}`

    router.replace(
      _href,
      options
    )
  }

  return {
    ...router,
    push,
    refresh,
    replace
  }
}
